import { render, staticRenderFns } from "./AddGithubSidePanel.vue?vue&type=template&id=e691c1bc&"
import script from "./AddGithubSidePanel.vue?vue&type=script&lang=ts&"
export * from "./AddGithubSidePanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports